<template>
	<div class="wrapNavigationAddress">
		<navigation-address-item
				v-for="(item, index) in items"
				:key="index"
				:index="index"
				:item="item"
		></navigation-address-item>
	</div>
</template>

<script>
import NavigationAddressItem from "@/components/Dispatch/Trips/DialogTrip/NavigationAddress/NavigationAddressItem";

export default {
	name: "NavigationAddress",
	components: {
		NavigationAddressItem,
	},
	props: {
		items: Array,
	},
	data() {
		return {
			// flag: PAGE.TRIP_NOTES,
			// list: null,
		};
	},
};
</script>

<style scoped lang="scss">
.wrapNavigationAddress {
	background: var(--card-bg-opacity);
}
</style>
